import(/* webpackMode: "eager" */ "/Users/zdenek/work/docusure/docusure-poc/src/app/error.tsx")